export { default } from './AuthenticatedRoute';
